import React, { useState, useEffect, useContext, useRef } from "react";
import {
  Container,
  Stack,
  AppBar,
  Toolbar,
  Typography,
  Dialog,
  IconButton,
  TableContainer,
  Table,
  TableCell,
  TableRow,
  TableHead,
  TableBody,
  Paper,
  Box,
  Divider,
} from "@mui/material";
import { isEmpty } from "lodash";
import ReactToPrint from "react-to-print";
import PrintRoundedIcon from "@mui/icons-material/PrintRounded";
import moment from "moment";
import { useParams } from "react-router-dom";
import { DataContext } from "../../../context/DataContext";
import { getToken, getUser } from "../../../api/Account";
import NoData from "../../../components/NoData";
import { getCierreCajaAsync } from "../../../api/Report";
import { simpleMessage } from "../../../helpers/Helpers";
import { PrintReport } from "../../../components/PrintReport";
import { getSucursalByUserAsync } from "../../../api/Users";
import { EncabezadoOrdenable, useOrdenTabla } from "../../../helpers/OrdenTabla";

const CierreCajaDetallado = () => {
  const [data, setData] = useState([]);

  const [sumDesembolsos, setSumDesembolsos] = useState(0);
  const [sumAbonoCajaChica, setSumAbonoCajaChica] = useState(0);
  const [sumGastosAdministrativos, setSumGastosAdministrativos] = useState(0);
  const [sumGastosOperativos, setSumGastosOperativos] = useState(0);
  const [sumAbonosAnulados, setSumAbonosAnulados] = useState(0);
  const [sumOtrosGastos, setSumOtrosGastos] = useState(0);

  const [sumRecuperacion, setSumRecuperacion] = useState(0);
  const [sumIngresoBancos, setSumIngresoBancos] = useState(0);
  const [sumOtrosIngresos, setSumOtrosIngresos] = useState(0);

  const [totalSalidas, setTotalSalidas] = useState(0);
  const [totalEntradas, setTotalEntradas] = useState(0);
  const [cierre, setCierre] = useState(0);

  const [sucursalName, setSucursalName] = useState("");
  const [sucursalList, setSucursalList] = useState([]);

  const compRef = useRef();
  const { selectedSucursal, fecha } = useParams();
  const { setIsLoading, setIsUnautorized, title, slogan, icon } =
    useContext(DataContext);

  const token = getToken();
  const user = getUser();

  const { orden: ordenDesembolsos, cambiarOrden: cambiarDesembolsos, ordenar: ordenarDesembolsos } = useOrdenTabla("id", ["client", "fechaEntrega"]);
  const { orden: ordenCajaChica, cambiarOrden: cambiarCajaChica, ordenar: ordenarCajaChica } = useOrdenTabla("id", ["fecha", "description"]);
  const { orden: ordenAnulados, cambiarOrden: cambiarAnulados, ordenar: ordenarAnulados } = useOrdenTabla("id", ["fecha", "concepto"]);
  const { orden: ordenGastosAdm, cambiarOrden: cambiarGastosAdm, ordenar: ordenarGastosAdm } = useOrdenTabla("id", ["fecha", "description"]);
  const { orden: ordenGastosOp, cambiarOrden: cambiarGastosOp, ordenar: ordenarGastosOp } = useOrdenTabla("id", ["fecha", "description"]);
  const { orden: ordenOtrosGastos, cambiarOrden: cambiarOtrosGastos, ordenar: ordenarOtrosGastos } = useOrdenTabla("id", ["fecha", "description"]);
  const { orden: ordenRecuperacion, cambiarOrden: cambiarRecuperacion, ordenar: ordenarRecuperacion } = useOrdenTabla("id", ["fecha", "concepto"]);
  const { orden: ordenIngresosBanco, cambiarOrden: cambiarIngresosBanco, ordenar: ordenarIngresosBanco } = useOrdenTabla("id", ["fecha", "description"]);
  const { orden: ordenOtrosIngresos, cambiarOrden: cambiarOtrosIngresos, ordenar: ordenarOtrosIngresos } = useOrdenTabla("id", ["fecha", "description"]);

  useEffect(() => {
    (async () => {
      setIsLoading(true);

      let sucursals = await getSucursals();
      if (selectedSucursal === "t") {
        setSucursalName("Todas");
      } else {
        let name = sucursals.filter((item) => {
          return item.id.toString() === selectedSucursal;
        });
        setSucursalName(name[0].description);
      }

      const data = {
        sucursalId: selectedSucursal === "t" ? 0 : selectedSucursal,
        fecha: fecha.toString(),
      };

      const result = await getCierreCajaAsync(token, data);
      if (!result.statusResponse) {
        setIsLoading(false);
        if (result.error === "Unauthorized") {
          setIsUnautorized(true);
          return;
        }
        simpleMessage(result.error, "error");
        return;
      }
      setIsLoading(false);
      setData(result.data.result);
      setTotales(result.data.result);
    })();
  }, []);

  const setTotales = (data) => {
    let totalDesembolsos = 0;
    let totalAbonoCajaChica = 0;
    let totalGastosAdministrativos = 0;
    let totalGastosOperativos = 0;
    let totalAbonosAnulados = 0;
    let totalOtrosGastos = 0;

    let totalRecuperacion = 0;
    let totalIngresosBanco = 0;
    let totalOtrosIngresos = 0;

    data.desembolsos.map((item) => (totalDesembolsos += item.montoEntregado));
    setSumDesembolsos(totalDesembolsos);

    data.abonoCajaChica.map((item) => (totalAbonoCajaChica += item.salidas));
    setSumAbonoCajaChica(totalAbonoCajaChica);

    data.gastosAdministrativos.map(
      (item) => (totalGastosAdministrativos += item.entradas)
    );
    setSumGastosAdministrativos(totalGastosAdministrativos);

    data.gastosOperativos.map(
      (item) => (totalGastosOperativos += item.entradas)
    );
    setSumGastosOperativos(totalGastosOperativos);

    data.abonosAnulados.map(
      (item) => (totalAbonosAnulados += item.totalRecibido)
    );
    setSumAbonosAnulados(totalAbonosAnulados);

    data.otrosGastos.map((item) => (totalOtrosGastos += item.salidas));
    setSumOtrosGastos(totalOtrosGastos);

    //ingresos
    data.recuperacion.map((item) => (totalRecuperacion += item.totalRecibido));
    setSumRecuperacion(totalRecuperacion);
    data.ingresosBanco.map((item) => (totalIngresosBanco += item.entradas));
    setSumIngresoBancos(totalIngresosBanco);
    data.otrosIngresos.map((item) => (totalOtrosIngresos += item.entradas));
    setSumOtrosIngresos(totalOtrosIngresos);

    setTotalSalidas(
      totalDesembolsos +
        totalAbonoCajaChica +
        totalGastosAdministrativos +
        totalGastosOperativos +
        totalOtrosGastos
    );

    setTotalEntradas(
      totalRecuperacion + totalIngresosBanco + totalOtrosIngresos
    );

    setCierre(
      totalRecuperacion +
        totalIngresosBanco +
        totalOtrosIngresos -
        (totalDesembolsos +
          totalAbonoCajaChica +
          totalAbonosAnulados +
          totalGastosAdministrativos +
          totalGastosOperativos +
          totalOtrosGastos)
    );
  };

  const pageStyle = `
  @media print {
    html, body {
      height: initial !important;
      overflow: initial !important;
      -webkit-print-color-adjust: exact;
    }
  }
  @media all {
    .pagebreak {
      display: none;
    }
  }
  @media print {
    .pagebreak {
      page-break-before: always;
    }
  }  
  @page {  margin: 5mm; }
`;

  const getSucursals = async () => {
    setIsLoading(true);
    const result = await getSucursalByUserAsync(token);
    if (!result.statusResponse) {
      setIsLoading(false);
      if (result.error === "Unauthorized") {
        setIsUnautorized(true);
        return;
      }
      simpleMessage(result.error, "error");
      return;
    }
    setIsLoading(false);

    setSucursalList(
      selectedSucursal === "t"
        ? result.data.result
        : result.data.result.filter((g) => g.id.toString() === selectedSucursal)
    );
    return result.data.result;
  };

  return (
    <div>
      <Dialog fullScreen open={true}>
        <AppBar sx={{ position: "relative" }}>
          <Toolbar>
            <img loading="lazy" src={icon} alt="logo" style={{ height: 40 }} />
            <Typography
              sx={{ ml: 2, flex: 1, textAlign: "center" }}
              variant="h5"
              component="div"
            >
              {`${title} `}
            </Typography>
            <img loading="lazy" src={icon} alt="logo" style={{ height: 40 }} />
          </Toolbar>
        </AppBar>

        <Stack display="flex" justifyContent="center">
          <Typography
            sx={{
              color: "text.secondary",
              textAlign: "center",
              fontWeight: "bold",
            }}
          >
            {slogan}
          </Typography>
          <Typography
            sx={{
              color: "text.secondary",
              textAlign: "center",
              fontWeight: "bold",
            }}
            variant="h6"
            component="div"
          >
            Reporte Cierre de Caja Detallado
          </Typography>

          <Box sx={{ paddingX: "22px", textAlign: "center" }}>
            <Stack direction={"row"} justifyContent="space-between">
              <Stack>
                <Typography
                  sx={{
                    color: "text.secondary",
                    textAlign: "left",
                  }}
                  fontSize={11}
                >
                  Parametros:
                </Typography>
                <Typography fontSize={11} textAlign="left">
                  Fecha Seleccionada:
                </Typography>

                <Typography fontSize={11} textAlign="left">
                  {moment(fecha).format("L")}
                </Typography>
              </Stack>
              <Stack>
                <Typography
                  sx={{
                    color: "text.secondary",
                    textAlign: "left",
                  }}
                  fontSize={11}
                >
                  Usuario:
                </Typography>
                <Typography fontSize={11} textAlign="left">
                  {user}
                </Typography>
                <Typography fontSize={11} textAlign="left">
                  {`Fecha y Hora: ${moment().format("DD/MM/YYYY hh:mm A")}`}
                </Typography>
              </Stack>
            </Stack>
          </Box>

          <ReactToPrint
            trigger={() => {
              return (
                <IconButton
                  variant="outlined"
                  style={{ position: "fixed", right: 20, top: 75 }}
                >
                  <PrintRoundedIcon
                    style={{ fontSize: 35, color: "#1d4ed8", width: 35 }}
                  />
                </IconButton>
              );
            }}
            content={() => compRef.current}
            pageStyle={pageStyle}
          />
        </Stack>

        <Box sx={{ paddingX: "22px", textAlign: "center" }}>
          <Divider sx={{ marginY: "14px" }} />

          {isEmpty(data) ? (
            <NoData />
          ) : (
            <>
              <Paper
                elevation={10}
                style={{
                  padding: 20,
                }}
              >
                <Typography
                  sx={{
                    color: "#c77f12",
                    textAlign: "center",
                    marginBottom: 1,
                  }}
                  fontSize={16}
                >
                  Egresos:
                </Typography>
                <Stack spacing={2}>
                  <Paper
                    elevation={10}
                    style={{
                      padding: 20,
                    }}
                  >
                    <Stack direction={"row"} justifyContent="space-between">
                      <Typography
                        sx={{
                          color: "text.secondary",
                          textAlign: "left",
                        }}
                        fontSize={13}
                      >
                        Desembolsos:
                      </Typography>
                      <Typography
                        sx={{
                          color: "#c77f12",
                          textAlign: "left",
                        }}
                        fontSize={13}
                      >
                        {`Σ= ${new Intl.NumberFormat("es-NI", {
                          style: "currency",
                          currency: "NIO",
                        }).format(sumDesembolsos)}`}
                      </Typography>
                    </Stack>
                    <TableContainer>
                      <Table aria-label="simple table" size="small">
                        <TableHead>
                          <TableRow>
                            <EncabezadoOrdenable campo="id" orden={ordenDesembolsos} cambiarOrden={cambiarDesembolsos}
                              align="center"
                              className="text-primary fw-bold"
                              style={{ fontSize: 12 }}
                            >
                              #
                            </EncabezadoOrdenable>
                            <EncabezadoOrdenable campo="client" orden={ordenDesembolsos} cambiarOrden={cambiarDesembolsos}
                              align="left"
                              className="text-primary fw-bold"
                              style={{ fontSize: 12 }}
                            >
                              Cliente
                            </EncabezadoOrdenable>

                            <EncabezadoOrdenable campo="montoEntregado" orden={ordenDesembolsos} cambiarOrden={cambiarDesembolsos}
                              align="center"
                              className="text-primary fw-bold"
                              style={{ fontSize: 12 }}
                            >
                              Monto Entregado
                            </EncabezadoOrdenable>
                            <EncabezadoOrdenable campo="fechaEntrega" orden={ordenDesembolsos} cambiarOrden={cambiarDesembolsos}
                              align="center"
                              className="text-primary fw-bold"
                              style={{ fontSize: 12 }}
                            >
                              Fecha de Entrega
                            </EncabezadoOrdenable>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {ordenarDesembolsos(data.desembolsos).map((row) => {
                            return (
                              <TableRow key={row.id}>
                                <TableCell
                                  align="center"
                                  component="th"
                                  scope="row"
                                  style={{ fontSize: 11 }}
                                >
                                  {row.id}
                                </TableCell>
                                <TableCell
                                  align="left"
                                  style={{ fontSize: 11 }}
                                >
                                  {row.client.fullName}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  style={{ fontSize: 11 }}
                                >
                                  {new Intl.NumberFormat("es-NI", {
                                    style: "currency",
                                    currency: "NIO",
                                  }).format(row.montoEntregado)}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  style={{ fontSize: 11 }}
                                >
                                  {moment(row.fechaEntrega).format("L")}
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Paper>

                  {/* <Paper
                    elevation={10}
                    style={{
                      padding: 20,
                    }}
                  >
                    <Stack direction={"row"} justifyContent="space-between">
                      <Typography
                        sx={{
                          color: "text.secondary",
                          textAlign: "left",
                        }}
                        fontSize={13}
                      >
                        Abonos a Caja Chica:
                      </Typography>
                      <Typography
                        sx={{
                          color: "#c77f12",
                          textAlign: "left",
                        }}
                        fontSize={13}
                      >
                        {`Σ= ${new Intl.NumberFormat("es-NI", {
                          style: "currency",
                          currency: "NIO",
                        }).format(sumAbonoCajaChica)}`}
                      </Typography>
                    </Stack>
                    <TableContainer>
                      <Table aria-label="simple table" size="small">
                        <TableHead>
                          <TableRow>
                            <EncabezadoOrdenable campo="id" orden={ordenCajaChica} cambiarOrden={cambiarCajaChica}
                              align="center"
                              className="text-primary fw-bold"
                              style={{ fontSize: 12 }}
                            >
                              #
                            </EncabezadoOrdenable>
                            <EncabezadoOrdenable campo="fecha" orden={ordenCajaChica} cambiarOrden={cambiarCajaChica}
                              align="center"
                              className="text-primary fw-bold"
                              style={{ fontSize: 12 }}
                            >
                              Fecha
                            </EncabezadoOrdenable>

                            <EncabezadoOrdenable campo="description" orden={ordenCajaChica} cambiarOrden={cambiarCajaChica}
                              align="left"
                              className="text-primary fw-bold"
                              style={{ fontSize: 12 }}
                            >
                              Descripcion
                            </EncabezadoOrdenable>
                            <EncabezadoOrdenable campo="salidas" orden={ordenCajaChica} cambiarOrden={cambiarCajaChica}
                              align="center"
                              className="text-primary fw-bold"
                              style={{ fontSize: 12 }}
                            >
                              Monto
                            </EncabezadoOrdenable>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {ordenarCajaChica(data.abonoCajaChica).map((row) => {
                            return (
                              <TableRow key={row.id}>
                                <TableCell
                                  align="center"
                                  component="th"
                                  scope="row"
                                  style={{ fontSize: 11 }}
                                >
                                  {row.id}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  style={{ fontSize: 11 }}
                                >
                                  {moment(row.fecha).format("L")}
                                </TableCell>
                                <TableCell
                                  align="left"
                                  style={{ fontSize: 11 }}
                                >
                                  {row.description}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  style={{ fontSize: 11 }}
                                >
                                  {new Intl.NumberFormat("es-NI", {
                                    style: "currency",
                                    currency: "NIO",
                                  }).format(row.salidas)}
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Paper> */}

                  <Paper
                    elevation={10}
                    style={{
                      padding: 20,
                    }}
                  >
                    <Stack direction={"row"} justifyContent="space-between">
                      <Typography
                        sx={{
                          color: "text.secondary",
                          textAlign: "left",
                        }}
                        fontSize={13}
                      >
                        Cuotas Anuladas:
                      </Typography>
                      <Typography
                        sx={{
                          color: "#c77f12",
                          textAlign: "left",
                        }}
                        fontSize={13}
                      >
                        {`Σ= ${new Intl.NumberFormat("es-NI", {
                          style: "currency",
                          currency: "NIO",
                        }).format(sumAbonosAnulados)}`}
                      </Typography>
                    </Stack>
                    <TableContainer>
                      <Table aria-label="simple table" size="small">
                        <TableHead>
                          <TableRow>
                            <EncabezadoOrdenable campo="id" orden={ordenAnulados} cambiarOrden={cambiarAnulados}
                              align="center"
                              className="text-primary fw-bold"
                              style={{ fontSize: 12 }}
                            >
                              #
                            </EncabezadoOrdenable>
                            <EncabezadoOrdenable campo="fecha" orden={ordenAnulados} cambiarOrden={cambiarAnulados}
                              align="center"
                              className="text-primary fw-bold"
                              style={{ fontSize: 12 }}
                            >
                              Fecha
                            </EncabezadoOrdenable>

                            <EncabezadoOrdenable campo="concepto" orden={ordenAnulados} cambiarOrden={cambiarAnulados}
                              align="left"
                              className="text-primary fw-bold"
                              style={{ fontSize: 12 }}
                            >
                              Concepto
                            </EncabezadoOrdenable>
                            <EncabezadoOrdenable campo="totalRecibido" orden={ordenAnulados} cambiarOrden={cambiarAnulados}
                              align="center"
                              className="text-primary fw-bold"
                              style={{ fontSize: 12 }}
                            >
                              Monto
                            </EncabezadoOrdenable>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {ordenarAnulados(data.abonosAnulados).map((row) => {
                            return (
                              <TableRow key={row.id}>
                                <TableCell
                                  align="center"
                                  component="th"
                                  scope="row"
                                  style={{ fontSize: 11 }}
                                >
                                  {row.id}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  style={{ fontSize: 11 }}
                                >
                                  {moment(row.fecha).format("L")}
                                </TableCell>
                                <TableCell
                                  align="left"
                                  style={{ fontSize: 11 }}
                                >
                                  {row.concepto}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  style={{ fontSize: 11 }}
                                >
                                  {new Intl.NumberFormat("es-NI", {
                                    style: "currency",
                                    currency: "NIO",
                                  }).format(row.totalRecibido)}
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Paper>

                  <Paper
                    elevation={10}
                    style={{
                      padding: 20,
                    }}
                  >
                    <Stack direction={"row"} justifyContent="space-between">
                      <Typography
                        sx={{
                          color: "text.secondary",
                          textAlign: "left",
                        }}
                        fontSize={13}
                      >
                        Gastos Administrativos:
                      </Typography>
                      <Typography
                        sx={{
                          color: "#c77f12",
                          textAlign: "left",
                        }}
                        fontSize={13}
                      >
                        {`Σ= ${new Intl.NumberFormat("es-NI", {
                          style: "currency",
                          currency: "NIO",
                        }).format(sumGastosAdministrativos)}`}
                      </Typography>
                    </Stack>
                    <TableContainer>
                      <Table aria-label="simple table" size="small">
                        <TableHead>
                          <TableRow>
                            <EncabezadoOrdenable campo="id" orden={ordenGastosAdm} cambiarOrden={cambiarGastosAdm}
                              align="center"
                              className="text-primary fw-bold"
                              style={{ fontSize: 12 }}
                            >
                              #
                            </EncabezadoOrdenable>
                            <EncabezadoOrdenable campo="fecha" orden={ordenGastosAdm} cambiarOrden={cambiarGastosAdm}
                              align="center"
                              className="text-primary fw-bold"
                              style={{ fontSize: 12 }}
                            >
                              Fecha
                            </EncabezadoOrdenable>

                            <EncabezadoOrdenable campo="description" orden={ordenGastosAdm} cambiarOrden={cambiarGastosAdm}
                              align="left"
                              className="text-primary fw-bold"
                              style={{ fontSize: 12 }}
                            >
                              Descripcion
                            </EncabezadoOrdenable>
                            <EncabezadoOrdenable campo="entradas" orden={ordenGastosAdm} cambiarOrden={cambiarGastosAdm}
                              align="center"
                              className="text-primary fw-bold"
                              style={{ fontSize: 12 }}
                            >
                              Monto
                            </EncabezadoOrdenable>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {ordenarGastosAdm(data.gastosAdministrativos).map((row) => {
                            return (
                              <TableRow key={row.id}>
                                <TableCell
                                  align="center"
                                  component="th"
                                  scope="row"
                                  style={{ fontSize: 11 }}
                                >
                                  {row.id}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  style={{ fontSize: 11 }}
                                >
                                  {moment(row.fecha).format("L")}
                                </TableCell>
                                <TableCell
                                  align="left"
                                  style={{ fontSize: 11 }}
                                >
                                  {row.description}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  style={{ fontSize: 11 }}
                                >
                                  {new Intl.NumberFormat("es-NI", {
                                    style: "currency",
                                    currency: "NIO",
                                  }).format(row.entradas)}
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Paper>

                  <Paper
                    elevation={10}
                    style={{
                      padding: 20,
                    }}
                  >
                    <Stack direction={"row"} justifyContent="space-between">
                      <Typography
                        sx={{
                          color: "text.secondary",
                          textAlign: "left",
                        }}
                        fontSize={13}
                      >
                        Gastos Operativos:
                      </Typography>
                      <Typography
                        sx={{
                          color: "#c77f12",
                          textAlign: "left",
                        }}
                        fontSize={13}
                      >
                        {`Σ= ${new Intl.NumberFormat("es-NI", {
                          style: "currency",
                          currency: "NIO",
                        }).format(sumGastosOperativos)}`}
                      </Typography>
                    </Stack>
                    <TableContainer>
                      <Table aria-label="simple table" size="small">
                        <TableHead>
                          <TableRow>
                            <EncabezadoOrdenable campo="id" orden={ordenGastosOp} cambiarOrden={cambiarGastosOp}
                              align="center"
                              className="text-primary fw-bold"
                              style={{ fontSize: 12 }}
                            >
                              #
                            </EncabezadoOrdenable>
                            <EncabezadoOrdenable campo="fecha" orden={ordenGastosOp} cambiarOrden={cambiarGastosOp}
                              align="center"
                              className="text-primary fw-bold"
                              style={{ fontSize: 12 }}
                            >
                              Fecha
                            </EncabezadoOrdenable>

                            <EncabezadoOrdenable campo="description" orden={ordenGastosOp} cambiarOrden={cambiarGastosOp}
                              align="left"
                              className="text-primary fw-bold"
                              style={{ fontSize: 12 }}
                            >
                              Descripcion
                            </EncabezadoOrdenable>
                            <EncabezadoOrdenable campo="entradas" orden={ordenGastosOp} cambiarOrden={cambiarGastosOp}
                              align="center"
                              className="text-primary fw-bold"
                              style={{ fontSize: 12 }}
                            >
                              Monto
                            </EncabezadoOrdenable>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {ordenarGastosOp(data.gastosOperativos).map((row) => {
                            return (
                              <TableRow key={row.id}>
                                <TableCell
                                  align="center"
                                  component="th"
                                  scope="row"
                                  style={{ fontSize: 11 }}
                                >
                                  {row.id}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  style={{ fontSize: 11 }}
                                >
                                  {moment(row.fecha).format("L")}
                                </TableCell>
                                <TableCell
                                  align="left"
                                  style={{ fontSize: 11 }}
                                >
                                  {row.description}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  style={{ fontSize: 11 }}
                                >
                                  {new Intl.NumberFormat("es-NI", {
                                    style: "currency",
                                    currency: "NIO",
                                  }).format(row.entradas)}
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Paper>

                  <Paper
                    elevation={10}
                    style={{
                      padding: 20,
                    }}
                  >
                    <Stack direction={"row"} justifyContent="space-between">
                      <Typography
                        sx={{
                          color: "text.secondary",
                          textAlign: "left",
                        }}
                        fontSize={13}
                      >
                        Otros Gastos:
                      </Typography>
                      <Typography
                        sx={{
                          color: "#c77f12",
                          textAlign: "left",
                        }}
                        fontSize={13}
                      >
                        {`Σ= ${new Intl.NumberFormat("es-NI", {
                          style: "currency",
                          currency: "NIO",
                        }).format(sumOtrosGastos)}`}
                      </Typography>
                    </Stack>
                    <TableContainer>
                      <Table aria-label="simple table" size="small">
                        <TableHead>
                          <TableRow>
                            <EncabezadoOrdenable campo="id" orden={ordenOtrosGastos} cambiarOrden={cambiarOtrosGastos}
                              align="center"
                              className="text-primary fw-bold"
                              style={{ fontSize: 12 }}
                            >
                              #
                            </EncabezadoOrdenable>
                            <EncabezadoOrdenable campo="fecha" orden={ordenOtrosGastos} cambiarOrden={cambiarOtrosGastos}
                              align="center"
                              className="text-primary fw-bold"
                              style={{ fontSize: 12 }}
                            >
                              Fecha
                            </EncabezadoOrdenable>

                            <EncabezadoOrdenable campo="description" orden={ordenOtrosGastos} cambiarOrden={cambiarOtrosGastos}
                              align="left"
                              className="text-primary fw-bold"
                              style={{ fontSize: 12 }}
                            >
                              Descripcion
                            </EncabezadoOrdenable>
                            <EncabezadoOrdenable campo="salidas" orden={ordenOtrosGastos} cambiarOrden={cambiarOtrosGastos}
                              align="center"
                              className="text-primary fw-bold"
                              style={{ fontSize: 12 }}
                            >
                              Monto
                            </EncabezadoOrdenable>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {ordenarOtrosGastos(data.otrosGastos).map((row) => {
                            return (
                              <TableRow key={row.id}>
                                <TableCell
                                  align="center"
                                  component="th"
                                  scope="row"
                                  style={{ fontSize: 11 }}
                                >
                                  {row.id}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  style={{ fontSize: 11 }}
                                >
                                  {moment(row.fecha).format("L")}
                                </TableCell>
                                <TableCell
                                  align="left"
                                  style={{ fontSize: 11 }}
                                >
                                  {row.description}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  style={{ fontSize: 11 }}
                                >
                                  {new Intl.NumberFormat("es-NI", {
                                    style: "currency",
                                    currency: "NIO",
                                  }).format(row.salidas)}
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Paper>
                </Stack>
              </Paper>

              <Divider sx={{ marginY: "14px" }} />

              <Paper
                elevation={10}
                style={{
                  padding: 20,
                }}
              >
                <Typography
                  sx={{
                    color: "#12a35a",
                    textAlign: "center",
                    marginBottom: 1,
                  }}
                  fontSize={16}
                >
                  Ingresos:
                </Typography>

                <Stack spacing={2}>
                  <Paper
                    elevation={10}
                    style={{
                      padding: 20,
                    }}
                  >
                    <Stack direction={"row"} justifyContent="space-between">
                      <Typography
                        sx={{
                          color: "text.secondary",
                          textAlign: "left",
                        }}
                        fontSize={13}
                      >
                        Recuperación:
                      </Typography>
                      <Typography
                        sx={{
                          color: "#12a35a",
                          textAlign: "left",
                        }}
                        fontSize={13}
                      >
                        {`Σ= ${new Intl.NumberFormat("es-NI", {
                          style: "currency",
                          currency: "NIO",
                        }).format(sumRecuperacion)}`}
                      </Typography>
                    </Stack>
                    <TableContainer>
                      <Table aria-label="simple table" size="small">
                        <TableHead>
                          <TableRow>
                            <EncabezadoOrdenable campo="id" orden={ordenRecuperacion} cambiarOrden={cambiarRecuperacion}
                              align="center"
                              className="text-primary fw-bold"
                              style={{ fontSize: 12 }}
                            >
                              #
                            </EncabezadoOrdenable>
                            <EncabezadoOrdenable campo="fecha" orden={ordenRecuperacion} cambiarOrden={cambiarRecuperacion}
                              align="center"
                              className="text-primary fw-bold"
                              style={{ fontSize: 12 }}
                            >
                              Fecha
                            </EncabezadoOrdenable>

                            <EncabezadoOrdenable campo="concepto" orden={ordenRecuperacion} cambiarOrden={cambiarRecuperacion}
                              align="left"
                              className="text-primary fw-bold"
                              style={{ fontSize: 12 }}
                            >
                              Concepto
                            </EncabezadoOrdenable>
                            <EncabezadoOrdenable campo="totalRecibido" orden={ordenRecuperacion} cambiarOrden={cambiarRecuperacion}
                              align="center"
                              className="text-primary fw-bold"
                              style={{ fontSize: 12 }}
                            >
                              Monto
                            </EncabezadoOrdenable>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {ordenarRecuperacion(data.recuperacion).map((row) => {
                            return (
                              <TableRow key={row.id}>
                                <TableCell
                                  align="center"
                                  component="th"
                                  scope="row"
                                  style={{ fontSize: 11 }}
                                >
                                  {row.id}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  style={{ fontSize: 11 }}
                                >
                                  {moment(row.fecha).format("L")}
                                </TableCell>
                                <TableCell
                                  align="left"
                                  style={{ fontSize: 11 }}
                                >
                                  {row.concepto}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  style={{ fontSize: 11 }}
                                >
                                  {new Intl.NumberFormat("es-NI", {
                                    style: "currency",
                                    currency: "NIO",
                                  }).format(row.totalRecibido)}
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Paper>

                  <Paper
                    elevation={10}
                    style={{
                      padding: 20,
                    }}
                  >
                    <Stack direction={"row"} justifyContent="space-between">
                      <Typography
                        sx={{
                          color: "text.secondary",
                          textAlign: "left",
                        }}
                        fontSize={13}
                      >
                        Ingreso de Bancos:
                      </Typography>
                      <Typography
                        sx={{
                          color: "#12a35a",
                          textAlign: "left",
                        }}
                        fontSize={13}
                      >
                        {`Σ= ${new Intl.NumberFormat("es-NI", {
                          style: "currency",
                          currency: "NIO",
                        }).format(sumIngresoBancos)}`}
                      </Typography>
                    </Stack>
                    <TableContainer>
                      <Table aria-label="simple table" size="small">
                        <TableHead>
                          <TableRow>
                            <EncabezadoOrdenable campo="id" orden={ordenIngresosBanco} cambiarOrden={cambiarIngresosBanco}
                              align="center"
                              className="text-primary fw-bold"
                              style={{ fontSize: 12 }}
                            >
                              #
                            </EncabezadoOrdenable>
                            <EncabezadoOrdenable campo="fecha" orden={ordenIngresosBanco} cambiarOrden={cambiarIngresosBanco}
                              align="center"
                              className="text-primary fw-bold"
                              style={{ fontSize: 12 }}
                            >
                              Fecha
                            </EncabezadoOrdenable>

                            <EncabezadoOrdenable campo="description" orden={ordenIngresosBanco} cambiarOrden={cambiarIngresosBanco}
                              align="left"
                              className="text-primary fw-bold"
                              style={{ fontSize: 12 }}
                            >
                              Descripcion
                            </EncabezadoOrdenable>
                            <EncabezadoOrdenable campo="entradas" orden={ordenIngresosBanco} cambiarOrden={cambiarIngresosBanco}
                              align="center"
                              className="text-primary fw-bold"
                              style={{ fontSize: 12 }}
                            >
                              Monto
                            </EncabezadoOrdenable>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {ordenarIngresosBanco(data.ingresosBanco).map((row) => {
                            return (
                              <TableRow key={row.id}>
                                <TableCell
                                  align="center"
                                  component="th"
                                  scope="row"
                                  style={{ fontSize: 11 }}
                                >
                                  {row.id}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  style={{ fontSize: 11 }}
                                >
                                  {moment(row.fecha).format("L")}
                                </TableCell>
                                <TableCell
                                  align="left"
                                  style={{ fontSize: 11 }}
                                >
                                  {row.description}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  style={{ fontSize: 11 }}
                                >
                                  {new Intl.NumberFormat("es-NI", {
                                    style: "currency",
                                    currency: "NIO",
                                  }).format(row.entradas)}
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Paper>

                  <Paper
                    elevation={10}
                    style={{
                      padding: 20,
                    }}
                  >
                    <Stack direction={"row"} justifyContent="space-between">
                      <Typography
                        sx={{
                          color: "text.secondary",
                          textAlign: "left",
                        }}
                        fontSize={13}
                      >
                        Otros Ingresos:
                      </Typography>
                      <Typography
                        sx={{
                          color: "#12a35a",
                          textAlign: "left",
                        }}
                        fontSize={13}
                      >
                        {`Σ= ${new Intl.NumberFormat("es-NI", {
                          style: "currency",
                          currency: "NIO",
                        }).format(sumOtrosIngresos)}`}
                      </Typography>
                    </Stack>
                    <TableContainer>
                      <Table aria-label="simple table" size="small">
                        <TableHead>
                          <TableRow>
                            <EncabezadoOrdenable campo="id" orden={ordenOtrosIngresos} cambiarOrden={cambiarOtrosIngresos}
                              align="center"
                              className="text-primary fw-bold"
                              style={{ fontSize: 12 }}
                            >
                              #
                            </EncabezadoOrdenable>
                            <EncabezadoOrdenable campo="fecha" orden={ordenOtrosIngresos} cambiarOrden={cambiarOtrosIngresos}
                              align="center"
                              className="text-primary fw-bold"
                              style={{ fontSize: 12 }}
                            >
                              Fecha
                            </EncabezadoOrdenable>

                            <EncabezadoOrdenable campo="description" orden={ordenOtrosIngresos} cambiarOrden={cambiarOtrosIngresos}
                              align="left"
                              className="text-primary fw-bold"
                              style={{ fontSize: 12 }}
                            >
                              Descripcion
                            </EncabezadoOrdenable>
                            <EncabezadoOrdenable campo="entradas" orden={ordenOtrosIngresos} cambiarOrden={cambiarOtrosIngresos}
                              align="center"
                              className="text-primary fw-bold"
                              style={{ fontSize: 12 }}
                            >
                              Monto
                            </EncabezadoOrdenable>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {ordenarOtrosIngresos(data.otrosIngresos).map((row) => {
                            return (
                              <TableRow key={row.id}>
                                <TableCell
                                  align="center"
                                  component="th"
                                  scope="row"
                                  style={{ fontSize: 11 }}
                                >
                                  {row.id}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  style={{ fontSize: 11 }}
                                >
                                  {moment(row.fecha).format("L")}
                                </TableCell>
                                <TableCell
                                  align="left"
                                  style={{ fontSize: 11 }}
                                >
                                  {row.description}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  style={{ fontSize: 11 }}
                                >
                                  {new Intl.NumberFormat("es-NI", {
                                    style: "currency",
                                    currency: "NIO",
                                  }).format(row.entradas)}
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Paper>
                </Stack>
              </Paper>

              <Divider sx={{ marginY: "14px" }} />

              <Paper
                elevation={10}
                style={{
                  padding: 20,
                }}
              >
                <Typography
                  sx={{
                    color: "#12a35a",
                    textAlign: "center",
                    marginBottom: 1,
                  }}
                  fontSize={16}
                >
                  Consolidado:
                </Typography>

                <Divider sx={{ marginY: "14px" }} />

                <TableContainer>
                  <Table aria-label="simple table" size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell
                          align="center"
                          className="text-primary fw-bold"
                          style={{ fontSize: 12 }}
                        >
                          Fecha
                        </TableCell>
                        <TableCell
                          align="left"
                          className="text-primary fw-bold"
                          style={{ fontSize: 12 }}
                        >
                          Descripción
                        </TableCell>

                        <TableCell
                          align="center"
                          className="text-primary fw-bold"
                          style={{ fontSize: 12 }}
                        >
                          Salida
                        </TableCell>
                        <TableCell
                          align="center"
                          className="text-primary fw-bold"
                          style={{ fontSize: 12 }}
                        >
                          Entrada
                        </TableCell>
                        <TableCell
                          align="center"
                          className="text-primary fw-bold"
                          style={{ fontSize: 12 }}
                        >
                          Saldo
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow key={1}>
                        <TableCell
                          align="center"
                          component="th"
                          scope="row"
                          style={{ fontSize: 11 }}
                        >
                          {moment(fecha).format("L")}
                        </TableCell>
                        <TableCell align="left" style={{ fontSize: 11 }}>
                          DESEMBOLSOS DEL DIA
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{ fontSize: 11, color: "#c77f12" }}
                        >
                          {new Intl.NumberFormat("es-NI", {
                            style: "currency",
                            currency: "NIO",
                          }).format(sumDesembolsos)}
                        </TableCell>
                        <TableCell align="center" style={{ fontSize: 11 }}>
                          {new Intl.NumberFormat("es-NI", {
                            style: "currency",
                            currency: "NIO",
                          }).format(0)}
                        </TableCell>
                        <TableCell align="center" style={{ fontSize: 11 }}>
                          {new Intl.NumberFormat("es-NI", {
                            style: "currency",
                            currency: "NIO",
                          }).format(0)}
                        </TableCell>
                      </TableRow>

                      {/* <TableRow key={2}>
                        <TableCell
                          align="center"
                          component="th"
                          scope="row"
                          style={{ fontSize: 11 }}
                        >
                          {moment(fecha).format("L")}
                        </TableCell>
                        <TableCell align="left" style={{ fontSize: 11 }}>
                          TRASLADO DE EFECTIVO A CAJA CHICA
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{ fontSize: 11, color: "#c77f12" }}
                        >
                          {new Intl.NumberFormat("es-NI", {
                            style: "currency",
                            currency: "NIO",
                          }).format(sumAbonoCajaChica)}
                        </TableCell>
                        <TableCell align="center" style={{ fontSize: 11 }}>
                          {new Intl.NumberFormat("es-NI", {
                            style: "currency",
                            currency: "NIO",
                          }).format(0)}
                        </TableCell>
                        <TableCell align="center" style={{ fontSize: 11 }}>
                          {new Intl.NumberFormat("es-NI", {
                            style: "currency",
                            currency: "NIO",
                          }).format(0)}
                        </TableCell>
                      </TableRow> */}

                      <TableRow key={4}>
                        <TableCell
                          align="center"
                          component="th"
                          scope="row"
                          style={{ fontSize: 11 }}
                        >
                          {moment(fecha).format("L")}
                        </TableCell>
                        <TableCell align="left" style={{ fontSize: 11 }}>
                          GASTOS ADMINISTRATIVOS
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{ fontSize: 11, color: "#c77f12" }}
                        >
                          {new Intl.NumberFormat("es-NI", {
                            style: "currency",
                            currency: "NIO",
                          }).format(sumGastosAdministrativos)}
                        </TableCell>
                        <TableCell align="center" style={{ fontSize: 11 }}>
                          {new Intl.NumberFormat("es-NI", {
                            style: "currency",
                            currency: "NIO",
                          }).format(0)}
                        </TableCell>
                        <TableCell align="center" style={{ fontSize: 11 }}>
                          {new Intl.NumberFormat("es-NI", {
                            style: "currency",
                            currency: "NIO",
                          }).format(0)}
                        </TableCell>
                      </TableRow>

                      <TableRow key={5}>
                        <TableCell
                          align="center"
                          component="th"
                          scope="row"
                          style={{ fontSize: 11 }}
                        >
                          {moment(fecha).format("L")}
                        </TableCell>
                        <TableCell align="left" style={{ fontSize: 11 }}>
                          GASTOS OPERATIVOS
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{ fontSize: 11, color: "#c77f12" }}
                        >
                          {new Intl.NumberFormat("es-NI", {
                            style: "currency",
                            currency: "NIO",
                          }).format(sumGastosOperativos)}
                        </TableCell>
                        <TableCell align="center" style={{ fontSize: 11 }}>
                          {new Intl.NumberFormat("es-NI", {
                            style: "currency",
                            currency: "NIO",
                          }).format(0)}
                        </TableCell>
                        <TableCell align="center" style={{ fontSize: 11 }}>
                          {new Intl.NumberFormat("es-NI", {
                            style: "currency",
                            currency: "NIO",
                          }).format(0)}
                        </TableCell>
                      </TableRow>

                      <TableRow key={6}>
                        <TableCell
                          align="center"
                          component="th"
                          scope="row"
                          style={{ fontSize: 11 }}
                        >
                          {moment(fecha).format("L")}
                        </TableCell>
                        <TableCell align="left" style={{ fontSize: 11 }}>
                          OTROS GASTOS
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{ fontSize: 11, color: "#c77f12" }}
                        >
                          {new Intl.NumberFormat("es-NI", {
                            style: "currency",
                            currency: "NIO",
                          }).format(sumOtrosGastos)}
                        </TableCell>
                        <TableCell align="center" style={{ fontSize: 11 }}>
                          {new Intl.NumberFormat("es-NI", {
                            style: "currency",
                            currency: "NIO",
                          }).format(0)}
                        </TableCell>
                        <TableCell align="center" style={{ fontSize: 11 }}>
                          {new Intl.NumberFormat("es-NI", {
                            style: "currency",
                            currency: "NIO",
                          }).format(0)}
                        </TableCell>
                      </TableRow>

                      <TableRow key={3}>
                        <TableCell
                          align="center"
                          component="th"
                          scope="row"
                          style={{ fontSize: 11 }}
                        >
                          {moment(fecha).format("L")}
                        </TableCell>
                        <TableCell align="left" style={{ fontSize: 11 }}>
                          ANULACIONES DE ABONOS
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{ fontSize: 11, color: "gray" }}
                        >
                          {new Intl.NumberFormat("es-NI", {
                            style: "currency",
                            currency: "NIO",
                          }).format(sumAbonosAnulados)}
                        </TableCell>
                        <TableCell align="center" style={{ fontSize: 11 }}>
                          {new Intl.NumberFormat("es-NI", {
                            style: "currency",
                            currency: "NIO",
                          }).format(0)}
                        </TableCell>
                        <TableCell align="center" style={{ fontSize: 11 }}>
                          {new Intl.NumberFormat("es-NI", {
                            style: "currency",
                            currency: "NIO",
                          }).format(0)}
                        </TableCell>
                      </TableRow>

                      <TableRow key={7}>
                        <TableCell
                          align="center"
                          component="th"
                          scope="row"
                          style={{ fontSize: 11 }}
                        >
                          {moment(fecha).format("L")}
                        </TableCell>
                        <TableCell align="left" style={{ fontSize: 11 }}>
                          RECUPERACION EFECTIVA DEL DIA
                        </TableCell>
                        <TableCell align="center" style={{ fontSize: 11 }}>
                          {new Intl.NumberFormat("es-NI", {
                            style: "currency",
                            currency: "NIO",
                          }).format(0)}
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{ fontSize: 11, color: "#12a35a" }}
                        >
                          {new Intl.NumberFormat("es-NI", {
                            style: "currency",
                            currency: "NIO",
                          }).format(sumRecuperacion)}
                        </TableCell>
                        <TableCell align="center" style={{ fontSize: 11 }}>
                          {new Intl.NumberFormat("es-NI", {
                            style: "currency",
                            currency: "NIO",
                          }).format(0)}
                        </TableCell>
                      </TableRow>

                      <TableRow key={8}>
                        <TableCell
                          align="center"
                          component="th"
                          scope="row"
                          style={{ fontSize: 11 }}
                        >
                          {moment(fecha).format("L")}
                        </TableCell>
                        <TableCell align="left" style={{ fontSize: 11 }}>
                          INGRESOS PROVENIENTE DE BANCOS
                        </TableCell>
                        <TableCell align="center" style={{ fontSize: 11 }}>
                          {new Intl.NumberFormat("es-NI", {
                            style: "currency",
                            currency: "NIO",
                          }).format(0)}
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{ fontSize: 11, color: "#12a35a" }}
                        >
                          {new Intl.NumberFormat("es-NI", {
                            style: "currency",
                            currency: "NIO",
                          }).format(sumIngresoBancos)}
                        </TableCell>
                        <TableCell align="center" style={{ fontSize: 11 }}>
                          {new Intl.NumberFormat("es-NI", {
                            style: "currency",
                            currency: "NIO",
                          }).format(0)}
                        </TableCell>
                      </TableRow>

                      <TableRow key={9}>
                        <TableCell
                          align="center"
                          component="th"
                          scope="row"
                          style={{ fontSize: 11 }}
                        >
                          {moment(fecha).format("L")}
                        </TableCell>
                        <TableCell align="left" style={{ fontSize: 11 }}>
                          OTROS INGRESOS
                        </TableCell>
                        <TableCell align="center" style={{ fontSize: 11 }}>
                          {new Intl.NumberFormat("es-NI", {
                            style: "currency",
                            currency: "NIO",
                          }).format(0)}
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{ fontSize: 11, color: "#12a35a" }}
                        >
                          {new Intl.NumberFormat("es-NI", {
                            style: "currency",
                            currency: "NIO",
                          }).format(sumOtrosIngresos)}
                        </TableCell>
                        <TableCell align="center" style={{ fontSize: 11 }}>
                          {new Intl.NumberFormat("es-NI", {
                            style: "currency",
                            currency: "NIO",
                          }).format(0)}
                        </TableCell>
                      </TableRow>

                      <TableRow key={10}>
                        <TableCell
                          align="center"
                          component="th"
                          scope="row"
                          style={{ fontSize: 16, fontWeight: "bold" }}
                        >
                          {moment(fecha).format("L")}
                        </TableCell>
                        <TableCell
                          align="left"
                          style={{ fontSize: 16, fontWeight: "bold" }}
                        >
                          CIERRE DE CAJA
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{
                            fontSize: 16,
                            color: "#c77f12",
                            fontWeight: "bold",
                          }}
                        >
                          {new Intl.NumberFormat("es-NI", {
                            style: "currency",
                            currency: "NIO",
                          }).format(totalSalidas)}
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{
                            fontSize: 16,
                            color: "#12a35a",
                            fontWeight: "bold",
                          }}
                        >
                          {new Intl.NumberFormat("es-NI", {
                            style: "currency",
                            currency: "NIO",
                          }).format(totalEntradas)}
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{
                            fontSize: 16,
                            color: "#1d4ed8",
                            fontWeight: "bold",
                          }}
                        >
                          {new Intl.NumberFormat("es-NI", {
                            style: "currency",
                            currency: "NIO",
                          }).format(cierre)}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>

                <Divider sx={{ marginY: "14px" }} />
              </Paper>
            </>
          )}
        </Box>
      </Dialog>

      <div
        style={{
          display: "none",
        }}
      >
        <PrintReport
          ref={compRef}
          titulo={"Reporte Cierre de Caja Detallado"}
          fecha={`Fecha: ${moment().format("L")}`}
        >
          <Stack direction={"row"} justifyContent="space-between">
            <Stack>
              <Typography
                sx={{
                  color: "#2196f3",
                  textAlign: "left",
                }}
                fontSize={11}
              >
                Parametros:
              </Typography>
              <Typography fontSize={11} textAlign="left">
                Fecha Seleccionada:
              </Typography>

              <Typography fontSize={11} textAlign="left">
                {moment(fecha).format("L")}
              </Typography>
            </Stack>

            <Stack>
              <Typography
                sx={{
                  color: "#2196f3",
                  textAlign: "left",
                }}
                fontSize={11}
              >
                Usuario:
              </Typography>
              <Typography fontSize={11} textAlign="left">
                {user}
              </Typography>
              <Typography fontSize={11} textAlign="left">
                {`Fecha y Hora: ${moment().format("DD/MM/YYYY hh:mm A")}`}
              </Typography>
            </Stack>
          </Stack>

          <Container maxWidth={false} sx={{ textAlign: "center" }}>
            <hr />

            {isEmpty(data) ? (
              <NoData />
            ) : (
              <>
                <Typography
                  sx={{
                    color: "#1d4ed8",
                    textAlign: "center",
                  }}
                  fontSize={16}
                >
                  Egresos:
                </Typography>
                <div>
                  <div>
                    <Stack direction={"row"} justifyContent="space-between">
                      <Typography
                        sx={{
                          color: "#2196f3",
                          textAlign: "left",
                        }}
                        fontSize={13}
                      >
                        Desembolsos:
                      </Typography>
                      <Typography
                        sx={{
                          color: "#c77f12",
                          textAlign: "left",
                        }}
                        fontSize={13}
                      >
                        {`Σ= ${new Intl.NumberFormat("es-NI", {
                          style: "currency",
                          currency: "NIO",
                        }).format(sumDesembolsos)}`}
                      </Typography>
                    </Stack>
                    <TableContainer>
                      <Table aria-label="simple table" size="small">
                        <TableHead>
                          <TableRow>
                            <EncabezadoOrdenable campo="id" orden={ordenDesembolsos} cambiarOrden={cambiarDesembolsos}
                              align="center"
                              className="text-primary fw-bold"
                              style={{ fontSize: 12 }}
                            >
                              #
                            </EncabezadoOrdenable>
                            <EncabezadoOrdenable campo="client" orden={ordenDesembolsos} cambiarOrden={cambiarDesembolsos}
                              align="left"
                              className="text-primary fw-bold"
                              style={{ fontSize: 12 }}
                            >
                              Cliente
                            </EncabezadoOrdenable>

                            <EncabezadoOrdenable campo="montoEntregado" orden={ordenDesembolsos} cambiarOrden={cambiarDesembolsos}
                              align="center"
                              className="text-primary fw-bold"
                              style={{ fontSize: 12 }}
                            >
                              Monto Entregado
                            </EncabezadoOrdenable>
                            <EncabezadoOrdenable campo="fechaEntrega" orden={ordenDesembolsos} cambiarOrden={cambiarDesembolsos}
                              align="center"
                              className="text-primary fw-bold"
                              style={{ fontSize: 12 }}
                            >
                              Fecha de Entrega
                            </EncabezadoOrdenable>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {ordenarDesembolsos(data.desembolsos).map((row) => {
                            return (
                              <TableRow key={row.id}>
                                <TableCell
                                  align="center"
                                  component="th"
                                  scope="row"
                                  style={{ fontSize: 11 }}
                                  className="text-dark"
                                >
                                  {row.id}
                                </TableCell>
                                <TableCell
                                  align="left"
                                  style={{ fontSize: 11 }}
                                  className="text-dark"
                                >
                                  {row.client.fullName}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  style={{ fontSize: 11 }}
                                  className="text-dark"
                                >
                                  {new Intl.NumberFormat("es-NI", {
                                    style: "currency",
                                    currency: "NIO",
                                  }).format(row.montoEntregado)}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  style={{ fontSize: 11 }}
                                  className="text-dark"
                                >
                                  {moment(row.fechaEntrega).format("L")}
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </div>

                  <hr />

                  {/* <div>
                    <Stack direction={"row"} justifyContent="space-between">
                      <Typography
                        sx={{
                          color: "#2196f3",
                          textAlign: "left",
                        }}
                        fontSize={13}
                      >
                        Abonos a Caja Chica:
                      </Typography>
                      <Typography
                        sx={{
                          color: "#c77f12",
                          textAlign: "left",
                        }}
                        fontSize={13}
                      >
                        {`Σ= ${new Intl.NumberFormat("es-NI", {
                          style: "currency",
                          currency: "NIO",
                        }).format(sumAbonoCajaChica)}`}
                      </Typography>
                    </Stack>

                    <TableContainer>
                      <Table aria-label="simple table" size="small">
                        <TableHead>
                          <TableRow>
                            <EncabezadoOrdenable campo="id" orden={ordenCajaChica} cambiarOrden={cambiarCajaChica}
                              align="center"
                              className="text-primary fw-bold"
                              style={{ fontSize: 12 }}
                            >
                              #
                            </EncabezadoOrdenable>
                            <EncabezadoOrdenable campo="fecha" orden={ordenCajaChica} cambiarOrden={cambiarCajaChica}
                              align="center"
                              className="text-primary fw-bold"
                              style={{ fontSize: 12 }}
                            >
                              Fecha
                            </EncabezadoOrdenable>

                            <EncabezadoOrdenable campo="description" orden={ordenCajaChica} cambiarOrden={cambiarCajaChica}
                              align="left"
                              className="text-primary fw-bold"
                              style={{ fontSize: 12 }}
                            >
                              Descripcion
                            </EncabezadoOrdenable>
                            <EncabezadoOrdenable campo="salidas" orden={ordenCajaChica} cambiarOrden={cambiarCajaChica}
                              align="center"
                              className="text-primary fw-bold"
                              style={{ fontSize: 12 }}
                            >
                              Monto
                            </EncabezadoOrdenable>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {ordenarCajaChica(data.abonoCajaChica).map((row) => {
                            return (
                              <TableRow key={row.id}>
                                <TableCell
                                  align="center"
                                  component="th"
                                  scope="row"
                                  style={{ fontSize: 11 }}
                                  className="text-dark"
                                >
                                  {row.id}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  style={{ fontSize: 11 }}
                                  className="text-dark"
                                >
                                  {moment(row.fecha).format("L")}
                                </TableCell>
                                <TableCell
                                  align="left"
                                  style={{ fontSize: 11 }}
                                  className="text-dark"
                                >
                                  {row.description}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  style={{ fontSize: 11 }}
                                  className="text-dark"
                                >
                                  {new Intl.NumberFormat("es-NI", {
                                    style: "currency",
                                    currency: "NIO",
                                  }).format(row.salidas)}
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </div> */}

                  <hr />

                  <div>
                    <Stack direction={"row"} justifyContent="space-between">
                      <Typography
                        sx={{
                          color: "#2196f3",
                          textAlign: "left",
                        }}
                        fontSize={13}
                      >
                        Cuotas Anuladas:
                      </Typography>
                      <Typography
                        sx={{
                          color: "#c77f12",
                          textAlign: "left",
                        }}
                        fontSize={13}
                      >
                        {`Σ= ${new Intl.NumberFormat("es-NI", {
                          style: "currency",
                          currency: "NIO",
                        }).format(sumAbonosAnulados)}`}
                      </Typography>
                    </Stack>
                    <TableContainer>
                      <Table aria-label="simple table" size="small">
                        <TableHead>
                          <TableRow>
                            <EncabezadoOrdenable campo="id" orden={ordenAnulados} cambiarOrden={cambiarAnulados}
                              align="center"
                              className="text-primary fw-bold"
                              style={{ fontSize: 12 }}
                            >
                              #
                            </EncabezadoOrdenable>
                            <EncabezadoOrdenable campo="fecha" orden={ordenAnulados} cambiarOrden={cambiarAnulados}
                              align="center"
                              className="text-primary fw-bold"
                              style={{ fontSize: 12 }}
                            >
                              Fecha
                            </EncabezadoOrdenable>

                            <EncabezadoOrdenable campo="concepto" orden={ordenAnulados} cambiarOrden={cambiarAnulados}
                              align="left"
                              className="text-primary fw-bold"
                              style={{ fontSize: 12 }}
                            >
                              Concepto
                            </EncabezadoOrdenable>
                            <EncabezadoOrdenable campo="totalRecibido" orden={ordenAnulados} cambiarOrden={cambiarAnulados}
                              align="center"
                              className="text-primary fw-bold"
                              style={{ fontSize: 12 }}
                            >
                              Monto
                            </EncabezadoOrdenable>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {ordenarAnulados(data.abonosAnulados).map((row) => {
                            return (
                              <TableRow key={row.id}>
                                <TableCell
                                  align="center"
                                  component="th"
                                  scope="row"
                                  style={{ fontSize: 11 }}
                                  className="text-dark"
                                >
                                  {row.id}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  style={{ fontSize: 11 }}
                                  className="text-dark"
                                >
                                  {moment(row.fecha).format("L")}
                                </TableCell>
                                <TableCell
                                  align="left"
                                  style={{ fontSize: 11 }}
                                  className="text-dark"
                                >
                                  {row.concepto}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  style={{ fontSize: 11 }}
                                  className="text-dark"
                                >
                                  {new Intl.NumberFormat("es-NI", {
                                    style: "currency",
                                    currency: "NIO",
                                  }).format(row.totalRecibido)}
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </div>

                  <hr />

                  <div>
                    <Stack direction={"row"} justifyContent="space-between">
                      <Typography
                        sx={{
                          color: "#2196f3",
                          textAlign: "left",
                        }}
                        fontSize={13}
                      >
                        Gastos Administrativos:
                      </Typography>
                      <Typography
                        sx={{
                          color: "#c77f12",
                          textAlign: "left",
                        }}
                        fontSize={13}
                      >
                        {`Σ= ${new Intl.NumberFormat("es-NI", {
                          style: "currency",
                          currency: "NIO",
                        }).format(sumGastosAdministrativos)}`}
                      </Typography>
                    </Stack>
                    <TableContainer>
                      <Table aria-label="simple table" size="small">
                        <TableHead>
                          <TableRow>
                            <EncabezadoOrdenable campo="id" orden={ordenGastosAdm} cambiarOrden={cambiarGastosAdm}
                              align="center"
                              className="text-primary fw-bold"
                              style={{ fontSize: 12 }}
                            >
                              #
                            </EncabezadoOrdenable>
                            <EncabezadoOrdenable campo="fecha" orden={ordenGastosAdm} cambiarOrden={cambiarGastosAdm}
                              align="center"
                              className="text-primary fw-bold"
                              style={{ fontSize: 12 }}
                            >
                              Fecha
                            </EncabezadoOrdenable>

                            <EncabezadoOrdenable campo="description" orden={ordenGastosAdm} cambiarOrden={cambiarGastosAdm}
                              align="left"
                              className="text-primary fw-bold"
                              style={{ fontSize: 12 }}
                            >
                              Descripcion
                            </EncabezadoOrdenable>
                            <EncabezadoOrdenable campo="entradas" orden={ordenGastosAdm} cambiarOrden={cambiarGastosAdm}
                              align="center"
                              className="text-primary fw-bold"
                              style={{ fontSize: 12 }}
                            >
                              Monto
                            </EncabezadoOrdenable>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {ordenarGastosAdm(data.gastosAdministrativos).map((row) => {
                            return (
                              <TableRow key={row.id}>
                                <TableCell
                                  align="center"
                                  component="th"
                                  scope="row"
                                  style={{ fontSize: 11 }}
                                  className="text-dark"
                                >
                                  {row.id}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  style={{ fontSize: 11 }}
                                  className="text-dark"
                                >
                                  {moment(row.fecha).format("L")}
                                </TableCell>
                                <TableCell
                                  align="left"
                                  style={{ fontSize: 11 }}
                                  className="text-dark"
                                >
                                  {row.description}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  style={{ fontSize: 11 }}
                                  className="text-dark"
                                >
                                  {new Intl.NumberFormat("es-NI", {
                                    style: "currency",
                                    currency: "NIO",
                                  }).format(row.entradas)}
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </div>

                  <hr />

                  <div>
                    <Stack direction={"row"} justifyContent="space-between">
                      <Typography
                        sx={{
                          color: "#2196f3",
                          textAlign: "left",
                        }}
                        fontSize={13}
                      >
                        Gastos Operativos:
                      </Typography>
                      <Typography
                        sx={{
                          color: "#c77f12",
                          textAlign: "left",
                        }}
                        fontSize={13}
                      >
                        {`Σ= ${new Intl.NumberFormat("es-NI", {
                          style: "currency",
                          currency: "NIO",
                        }).format(sumGastosOperativos)}`}
                      </Typography>
                    </Stack>
                    <TableContainer>
                      <Table aria-label="simple table" size="small">
                        <TableHead>
                          <TableRow>
                            <EncabezadoOrdenable campo="id" orden={ordenGastosOp} cambiarOrden={cambiarGastosOp}
                              align="center"
                              className="text-primary fw-bold"
                              style={{ fontSize: 12 }}
                            >
                              #
                            </EncabezadoOrdenable>
                            <EncabezadoOrdenable campo="fecha" orden={ordenGastosOp} cambiarOrden={cambiarGastosOp}
                              align="center"
                              className="text-primary fw-bold"
                              style={{ fontSize: 12 }}
                            >
                              Fecha
                            </EncabezadoOrdenable>

                            <EncabezadoOrdenable campo="description" orden={ordenGastosOp} cambiarOrden={cambiarGastosOp}
                              align="left"
                              className="text-primary fw-bold"
                              style={{ fontSize: 12 }}
                            >
                              Descripcion
                            </EncabezadoOrdenable>
                            <EncabezadoOrdenable campo="entradas" orden={ordenGastosOp} cambiarOrden={cambiarGastosOp}
                              align="center"
                              className="text-primary fw-bold"
                              style={{ fontSize: 12 }}
                            >
                              Monto
                            </EncabezadoOrdenable>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {ordenarGastosOp(data.gastosOperativos).map((row) => {
                            return (
                              <TableRow key={row.id}>
                                <TableCell
                                  align="center"
                                  component="th"
                                  scope="row"
                                  style={{ fontSize: 11 }}
                                  className="text-dark"
                                >
                                  {row.id}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  style={{ fontSize: 11 }}
                                  className="text-dark"
                                >
                                  {moment(row.fecha).format("L")}
                                </TableCell>
                                <TableCell
                                  align="left"
                                  style={{ fontSize: 11 }}
                                  className="text-dark"
                                >
                                  {row.description}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  style={{ fontSize: 11 }}
                                  className="text-dark"
                                >
                                  {new Intl.NumberFormat("es-NI", {
                                    style: "currency",
                                    currency: "NIO",
                                  }).format(row.entradas)}
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </div>

                  <div>
                    <Stack direction={"row"} justifyContent="space-between">
                      <Typography
                        sx={{
                          color: "#2196f3",
                          textAlign: "left",
                        }}
                        fontSize={13}
                      >
                        Otros Gastos:
                      </Typography>
                      <Typography
                        sx={{
                          color: "#c77f12",
                          textAlign: "left",
                        }}
                        fontSize={13}
                      >
                        {`Σ= ${new Intl.NumberFormat("es-NI", {
                          style: "currency",
                          currency: "NIO",
                        }).format(sumOtrosGastos)}`}
                      </Typography>
                    </Stack>
                    <TableContainer>
                      <Table aria-label="simple table" size="small">
                        <TableHead>
                          <TableRow>
                            <EncabezadoOrdenable campo="id" orden={ordenOtrosGastos} cambiarOrden={cambiarOtrosGastos}
                              align="center"
                              className="text-primary fw-bold"
                              style={{ fontSize: 12 }}
                            >
                              #
                            </EncabezadoOrdenable>
                            <EncabezadoOrdenable campo="fecha" orden={ordenOtrosGastos} cambiarOrden={cambiarOtrosGastos}
                              align="center"
                              className="text-primary fw-bold"
                              style={{ fontSize: 12 }}
                            >
                              Fecha
                            </EncabezadoOrdenable>

                            <EncabezadoOrdenable campo="description" orden={ordenOtrosGastos} cambiarOrden={cambiarOtrosGastos}
                              align="left"
                              className="text-primary fw-bold"
                              style={{ fontSize: 12 }}
                            >
                              Descripcion
                            </EncabezadoOrdenable>
                            <EncabezadoOrdenable campo="salidas" orden={ordenOtrosGastos} cambiarOrden={cambiarOtrosGastos}
                              align="center"
                              className="text-primary fw-bold"
                              style={{ fontSize: 12 }}
                            >
                              Monto
                            </EncabezadoOrdenable>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {ordenarOtrosGastos(data.otrosGastos).map((row) => {
                            return (
                              <TableRow key={row.id}>
                                <TableCell
                                  align="center"
                                  component="th"
                                  scope="row"
                                  style={{ fontSize: 11 }}
                                  className="text-dark"
                                >
                                  {row.id}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  style={{ fontSize: 11 }}
                                  className="text-dark"
                                >
                                  {moment(row.fecha).format("L")}
                                </TableCell>
                                <TableCell
                                  align="left"
                                  style={{ fontSize: 11 }}
                                  className="text-dark"
                                >
                                  {row.description}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  style={{ fontSize: 11 }}
                                  className="text-dark"
                                >
                                  {new Intl.NumberFormat("es-NI", {
                                    style: "currency",
                                    currency: "NIO",
                                  }).format(row.salidas)}
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </div>
                </div>

                <hr />

                <div>
                  <Typography
                    sx={{
                      color: "#12a35a",
                      textAlign: "center",
                      marginBottom: 1,
                    }}
                    fontSize={16}
                  >
                    Ingresos:
                  </Typography>

                  <Stack spacing={2}>
                    <div>
                      <Stack direction={"row"} justifyContent="space-between">
                        <Typography
                          sx={{
                            color: "#2196f3",
                            textAlign: "left",
                          }}
                          fontSize={13}
                        >
                          Recuperación:
                        </Typography>
                        <Typography
                          sx={{
                            color: "#12a35a",
                            textAlign: "left",
                          }}
                          fontSize={13}
                        >
                          {`Σ= ${new Intl.NumberFormat("es-NI", {
                            style: "currency",
                            currency: "NIO",
                          }).format(sumRecuperacion)}`}
                        </Typography>
                      </Stack>
                      <TableContainer>
                        <Table aria-label="simple table" size="small">
                          <TableHead>
                            <TableRow>
                              <EncabezadoOrdenable campo="id" orden={ordenRecuperacion} cambiarOrden={cambiarRecuperacion}
                                align="center"
                                className="text-primary fw-bold"
                                style={{ fontSize: 12 }}
                              >
                                #
                              </EncabezadoOrdenable>
                              <EncabezadoOrdenable campo="fecha" orden={ordenRecuperacion} cambiarOrden={cambiarRecuperacion}
                                align="center"
                                className="text-primary fw-bold"
                                style={{ fontSize: 12 }}
                              >
                                Fecha
                              </EncabezadoOrdenable>

                              <EncabezadoOrdenable campo="concepto" orden={ordenRecuperacion} cambiarOrden={cambiarRecuperacion}
                                align="left"
                                className="text-primary fw-bold"
                                style={{ fontSize: 12 }}
                              >
                                Concepto
                              </EncabezadoOrdenable>
                              <EncabezadoOrdenable campo="totalRecibido" orden={ordenRecuperacion} cambiarOrden={cambiarRecuperacion}
                                align="center"
                                className="text-primary fw-bold"
                                style={{ fontSize: 12 }}
                              >
                                Monto
                              </EncabezadoOrdenable>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {ordenarRecuperacion(data.recuperacion).map((row) => {
                              return (
                                <TableRow key={row.id}>
                                  <TableCell
                                    align="center"
                                    component="th"
                                    scope="row"
                                    style={{ fontSize: 11 }}
                                    className="text-dark"
                                  >
                                    {row.id}
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    style={{ fontSize: 11 }}
                                    className="text-dark"
                                  >
                                    {moment(row.fecha).format("L")}
                                  </TableCell>
                                  <TableCell
                                    align="left"
                                    style={{ fontSize: 11 }}
                                    className="text-dark"
                                  >
                                    {row.concepto}
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    style={{ fontSize: 11 }}
                                    className="text-dark"
                                  >
                                    {new Intl.NumberFormat("es-NI", {
                                      style: "currency",
                                      currency: "NIO",
                                    }).format(row.totalRecibido)}
                                  </TableCell>
                                </TableRow>
                              );
                            })}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </div>

                    <hr />

                    <div>
                      <Stack direction={"row"} justifyContent="space-between">
                        <Typography
                          sx={{
                            color: "#2196f3",
                            textAlign: "left",
                          }}
                          fontSize={13}
                        >
                          Ingreso de Bancos:
                        </Typography>
                        <Typography
                          sx={{
                            color: "#12a35a",
                            textAlign: "left",
                          }}
                          fontSize={13}
                        >
                          {`Σ= ${new Intl.NumberFormat("es-NI", {
                            style: "currency",
                            currency: "NIO",
                          }).format(sumIngresoBancos)}`}
                        </Typography>
                      </Stack>
                      <TableContainer>
                        <Table aria-label="simple table" size="small">
                          <TableHead>
                            <TableRow>
                              <EncabezadoOrdenable campo="id" orden={ordenIngresosBanco} cambiarOrden={cambiarIngresosBanco}
                                align="center"
                                className="text-primary fw-bold"
                                style={{ fontSize: 12 }}
                              >
                                #
                              </EncabezadoOrdenable>
                              <EncabezadoOrdenable campo="fecha" orden={ordenIngresosBanco} cambiarOrden={cambiarIngresosBanco}
                                align="center"
                                className="text-primary fw-bold"
                                style={{ fontSize: 12 }}
                              >
                                Fecha
                              </EncabezadoOrdenable>

                              <EncabezadoOrdenable campo="description" orden={ordenIngresosBanco} cambiarOrden={cambiarIngresosBanco}
                                align="left"
                                className="text-primary fw-bold"
                                style={{ fontSize: 12 }}
                              >
                                Descripcion
                              </EncabezadoOrdenable>
                              <EncabezadoOrdenable campo="entradas" orden={ordenIngresosBanco} cambiarOrden={cambiarIngresosBanco}
                                align="center"
                                className="text-primary fw-bold"
                                style={{ fontSize: 12 }}
                              >
                                Monto
                              </EncabezadoOrdenable>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {ordenarIngresosBanco(data.ingresosBanco).map((row) => {
                              return (
                                <TableRow key={row.id}>
                                  <TableCell
                                    align="center"
                                    component="th"
                                    scope="row"
                                    style={{ fontSize: 11 }}
                                    className="text-dark"
                                  >
                                    {row.id}
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    style={{ fontSize: 11 }}
                                    className="text-dark"
                                  >
                                    {moment(row.fecha).format("L")}
                                  </TableCell>
                                  <TableCell
                                    align="left"
                                    style={{ fontSize: 11 }}
                                    className="text-dark"
                                  >
                                    {row.description}
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    style={{ fontSize: 11 }}
                                    className="text-dark"
                                  >
                                    {new Intl.NumberFormat("es-NI", {
                                      style: "currency",
                                      currency: "NIO",
                                    }).format(row.entradas)}
                                  </TableCell>
                                </TableRow>
                              );
                            })}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </div>

                    <hr />

                    <div>
                      <Stack direction={"row"} justifyContent="space-between">
                        <Typography
                          sx={{
                            color: "#2196f3",
                            textAlign: "left",
                          }}
                          fontSize={13}
                        >
                          Otros Ingresos:
                        </Typography>
                        <Typography
                          sx={{
                            color: "#12a35a",
                            textAlign: "left",
                          }}
                          fontSize={13}
                        >
                          {`Σ= ${new Intl.NumberFormat("es-NI", {
                            style: "currency",
                            currency: "NIO",
                          }).format(sumOtrosIngresos)}`}
                        </Typography>
                      </Stack>
                      <TableContainer>
                        <Table aria-label="simple table" size="small">
                          <TableHead>
                            <TableRow>
                              <EncabezadoOrdenable campo="id" orden={ordenOtrosIngresos} cambiarOrden={cambiarOtrosIngresos}
                                align="center"
                                className="text-primary fw-bold"
                                style={{ fontSize: 12 }}
                              >
                                #
                              </EncabezadoOrdenable>
                              <EncabezadoOrdenable campo="fecha" orden={ordenOtrosIngresos} cambiarOrden={cambiarOtrosIngresos}
                                align="center"
                                className="text-primary fw-bold"
                                style={{ fontSize: 12 }}
                              >
                                Fecha
                              </EncabezadoOrdenable>

                              <EncabezadoOrdenable campo="description" orden={ordenOtrosIngresos} cambiarOrden={cambiarOtrosIngresos}
                                align="left"
                                className="text-primary fw-bold"
                                style={{ fontSize: 12 }}
                              >
                                Descripcion
                              </EncabezadoOrdenable>
                              <EncabezadoOrdenable campo="entradas" orden={ordenOtrosIngresos} cambiarOrden={cambiarOtrosIngresos}
                                align="center"
                                className="text-primary fw-bold"
                                style={{ fontSize: 12 }}
                              >
                                Monto
                              </EncabezadoOrdenable>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {ordenarOtrosIngresos(data.otrosIngresos).map((row) => {
                              return (
                                <TableRow key={row.id}>
                                  <TableCell
                                    align="center"
                                    component="th"
                                    scope="row"
                                    style={{ fontSize: 11 }}
                                    className="text-dark"
                                  >
                                    {row.id}
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    style={{ fontSize: 11 }}
                                    className="text-dark"
                                  >
                                    {moment(row.fecha).format("L")}
                                  </TableCell>
                                  <TableCell
                                    align="left"
                                    style={{ fontSize: 11 }}
                                    className="text-dark"
                                  >
                                    {row.description}
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    style={{ fontSize: 11 }}
                                    className="text-dark"
                                  >
                                    {new Intl.NumberFormat("es-NI", {
                                      style: "currency",
                                      currency: "NIO",
                                    }).format(row.entradas)}
                                  </TableCell>
                                </TableRow>
                              );
                            })}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </div>
                  </Stack>
                </div>

                <hr />

                <div>
                  <Typography
                    sx={{
                      color: "#12a35a",
                      textAlign: "center",
                      marginBottom: 1,
                    }}
                    fontSize={16}
                  >
                    Consolidado:
                  </Typography>

                  <TableContainer>
                    <Table aria-label="simple table" size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell
                            align="center"
                            className="text-primary fw-bold"
                            style={{ fontSize: 12 }}
                          >
                            Fecha
                          </TableCell>
                          <TableCell
                            align="left"
                            className="text-primary fw-bold"
                            style={{ fontSize: 12 }}
                          >
                            Descripción
                          </TableCell>

                          <TableCell
                            align="center"
                            className="text-primary fw-bold"
                            style={{ fontSize: 12 }}
                          >
                            Salida
                          </TableCell>
                          <TableCell
                            align="center"
                            className="text-primary fw-bold"
                            style={{ fontSize: 12 }}
                          >
                            Entrada
                          </TableCell>
                          <TableCell
                            align="center"
                            className="text-primary fw-bold"
                            style={{ fontSize: 12 }}
                          >
                            Saldo
                          </TableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        <TableRow key={1}>
                          <TableCell
                            align="center"
                            component="th"
                            scope="row"
                            style={{ fontSize: 11 }}
                            className="text-dark"
                          >
                            {moment(fecha).format("L")}
                          </TableCell>
                          <TableCell
                            align="left"
                            className="text-dark"
                            style={{ fontSize: 11 }}
                          >
                            DESEMBOLSOS DEL DIA
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{ fontSize: 11, color: "#c77f12" }}
                            className="text-dark"
                          >
                            {new Intl.NumberFormat("es-NI", {
                              style: "currency",
                              currency: "NIO",
                            }).format(sumDesembolsos)}
                          </TableCell>
                          <TableCell
                            align="center"
                            className="text-dark"
                            style={{ fontSize: 11 }}
                          >
                            {new Intl.NumberFormat("es-NI", {
                              style: "currency",
                              currency: "NIO",
                            }).format(0)}
                          </TableCell>
                          <TableCell
                            align="center"
                            className="text-dark"
                            style={{ fontSize: 11 }}
                          >
                            {new Intl.NumberFormat("es-NI", {
                              style: "currency",
                              currency: "NIO",
                            }).format(0)}
                          </TableCell>
                        </TableRow>

                        {/* <TableRow key={2}>
                          <TableCell
                            align="center"
                            component="th"
                            scope="row"
                            style={{ fontSize: 11 }}
                            className="text-dark"
                          >
                            {moment(fecha).format("L")}
                          </TableCell>
                          <TableCell
                            align="left"
                            className="text-dark"
                            style={{ fontSize: 11 }}
                          >
                            TRASLADO DE EFECTIVO A CAJA CHICA
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{ fontSize: 11, color: "#c77f12" }}
                            className="text-dark"
                          >
                            {new Intl.NumberFormat("es-NI", {
                              style: "currency",
                              currency: "NIO",
                            }).format(sumAbonoCajaChica)}
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{ fontSize: 11 }}
                            className="text-dark"
                          >
                            {new Intl.NumberFormat("es-NI", {
                              style: "currency",
                              currency: "NIO",
                            }).format(0)}
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{ fontSize: 11 }}
                            className="text-dark"
                          >
                            {new Intl.NumberFormat("es-NI", {
                              style: "currency",
                              currency: "NIO",
                            }).format(0)}
                          </TableCell>
                        </TableRow> */}

                        <TableRow key={4}>
                          <TableCell
                            align="center"
                            component="th"
                            scope="row"
                            style={{ fontSize: 11 }}
                            className="text-dark"
                          >
                            {moment(fecha).format("L")}
                          </TableCell>
                          <TableCell
                            align="left"
                            style={{ fontSize: 11 }}
                            className="text-dark"
                          >
                            GASTOS ADMINISTRATIVOS
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{ fontSize: 11, color: "#c77f12" }}
                            className="text-dark"
                          >
                            {new Intl.NumberFormat("es-NI", {
                              style: "currency",
                              currency: "NIO",
                            }).format(sumGastosAdministrativos)}
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{ fontSize: 11 }}
                            className="text-dark"
                          >
                            {new Intl.NumberFormat("es-NI", {
                              style: "currency",
                              currency: "NIO",
                            }).format(0)}
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{ fontSize: 11 }}
                            className="text-dark"
                          >
                            {new Intl.NumberFormat("es-NI", {
                              style: "currency",
                              currency: "NIO",
                            }).format(0)}
                          </TableCell>
                        </TableRow>

                        <TableRow key={5}>
                          <TableCell
                            align="center"
                            component="th"
                            scope="row"
                            style={{ fontSize: 11 }}
                            className="text-dark"
                          >
                            {moment(fecha).format("L")}
                          </TableCell>
                          <TableCell
                            align="left"
                            style={{ fontSize: 11 }}
                            className="text-dark"
                          >
                            GASTOS OPERATIVOS
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{ fontSize: 11, color: "#c77f12" }}
                            className="text-dark"
                          >
                            {new Intl.NumberFormat("es-NI", {
                              style: "currency",
                              currency: "NIO",
                            }).format(sumGastosOperativos)}
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{ fontSize: 11 }}
                            className="text-dark"
                          >
                            {new Intl.NumberFormat("es-NI", {
                              style: "currency",
                              currency: "NIO",
                            }).format(0)}
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{ fontSize: 11 }}
                            className="text-dark"
                          >
                            {new Intl.NumberFormat("es-NI", {
                              style: "currency",
                              currency: "NIO",
                            }).format(0)}
                          </TableCell>
                        </TableRow>

                        <TableRow key={6}>
                          <TableCell
                            align="center"
                            component="th"
                            scope="row"
                            style={{ fontSize: 11 }}
                            className="text-dark"
                          >
                            {moment(fecha).format("L")}
                          </TableCell>
                          <TableCell
                            align="left"
                            style={{ fontSize: 11 }}
                            className="text-dark"
                          >
                            OTROS GASTOS
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{ fontSize: 11, color: "#c77f12" }}
                            className="text-dark"
                          >
                            {new Intl.NumberFormat("es-NI", {
                              style: "currency",
                              currency: "NIO",
                            }).format(sumOtrosGastos)}
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{ fontSize: 11 }}
                            className="text-dark"
                          >
                            {new Intl.NumberFormat("es-NI", {
                              style: "currency",
                              currency: "NIO",
                            }).format(0)}
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{ fontSize: 11 }}
                            className="text-dark"
                          >
                            {new Intl.NumberFormat("es-NI", {
                              style: "currency",
                              currency: "NIO",
                            }).format(0)}
                          </TableCell>
                        </TableRow>

                        <TableRow key={3}>
                          <TableCell
                            align="center"
                            component="th"
                            scope="row"
                            style={{ fontSize: 11 }}
                            className="text-dark"
                          >
                            {moment(fecha).format("L")}
                          </TableCell>
                          <TableCell
                            align="left"
                            style={{ fontSize: 11 }}
                            className="text-dark"
                          >
                            ANULACIONES DE ABONOS
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{ fontSize: 11, color: "gray" }}
                            className="text-dark"
                          >
                            {new Intl.NumberFormat("es-NI", {
                              style: "currency",
                              currency: "NIO",
                            }).format(sumAbonosAnulados)}
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{ fontSize: 11 }}
                            className="text-dark"
                          >
                            {new Intl.NumberFormat("es-NI", {
                              style: "currency",
                              currency: "NIO",
                            }).format(0)}
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{ fontSize: 11 }}
                            className="text-dark"
                          >
                            {new Intl.NumberFormat("es-NI", {
                              style: "currency",
                              currency: "NIO",
                            }).format(0)}
                          </TableCell>
                        </TableRow>

                        <TableRow key={7}>
                          <TableCell
                            align="center"
                            component="th"
                            scope="row"
                            style={{ fontSize: 11 }}
                            className="text-dark"
                          >
                            {moment(fecha).format("L")}
                          </TableCell>
                          <TableCell
                            align="left"
                            style={{ fontSize: 11 }}
                            className="text-dark"
                          >
                            RECUPERACION EFECTIVA DEL DIA
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{ fontSize: 11 }}
                            className="text-dark"
                          >
                            {new Intl.NumberFormat("es-NI", {
                              style: "currency",
                              currency: "NIO",
                            }).format(0)}
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{ fontSize: 11, color: "#12a35a" }}
                            className="text-dark"
                          >
                            {new Intl.NumberFormat("es-NI", {
                              style: "currency",
                              currency: "NIO",
                            }).format(sumRecuperacion)}
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{ fontSize: 11 }}
                            className="text-dark"
                          >
                            {new Intl.NumberFormat("es-NI", {
                              style: "currency",
                              currency: "NIO",
                            }).format(0)}
                          </TableCell>
                        </TableRow>

                        <TableRow key={8}>
                          <TableCell
                            align="center"
                            component="th"
                            scope="row"
                            style={{ fontSize: 11 }}
                            className="text-dark"
                          >
                            {moment(fecha).format("L")}
                          </TableCell>
                          <TableCell
                            align="left"
                            style={{ fontSize: 11 }}
                            className="text-dark"
                          >
                            INGRESOS PROVENIENTE DE BANCOS
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{ fontSize: 11 }}
                            className="text-dark"
                          >
                            {new Intl.NumberFormat("es-NI", {
                              style: "currency",
                              currency: "NIO",
                            }).format(0)}
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{ fontSize: 11, color: "#12a35a" }}
                            className="text-dark"
                          >
                            {new Intl.NumberFormat("es-NI", {
                              style: "currency",
                              currency: "NIO",
                            }).format(sumIngresoBancos)}
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{ fontSize: 11 }}
                            className="text-dark"
                          >
                            {new Intl.NumberFormat("es-NI", {
                              style: "currency",
                              currency: "NIO",
                            }).format(0)}
                          </TableCell>
                        </TableRow>

                        <TableRow key={9}>
                          <TableCell
                            align="center"
                            component="th"
                            scope="row"
                            style={{ fontSize: 11 }}
                            className="text-dark"
                          >
                            {moment(fecha).format("L")}
                          </TableCell>
                          <TableCell
                            align="left"
                            style={{ fontSize: 11 }}
                            className="text-dark"
                          >
                            OTROS INGRESOS
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{ fontSize: 11 }}
                            className="text-dark"
                          >
                            {new Intl.NumberFormat("es-NI", {
                              style: "currency",
                              currency: "NIO",
                            }).format(0)}
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{ fontSize: 11, color: "#12a35a" }}
                            className="text-dark"
                          >
                            {new Intl.NumberFormat("es-NI", {
                              style: "currency",
                              currency: "NIO",
                            }).format(sumOtrosIngresos)}
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{ fontSize: 11 }}
                            className="text-dark"
                          >
                            {new Intl.NumberFormat("es-NI", {
                              style: "currency",
                              currency: "NIO",
                            }).format(0)}
                          </TableCell>
                        </TableRow>

                        <TableRow key={10}>
                          <TableCell
                            align="center"
                            component="th"
                            scope="row"
                            style={{ fontSize: 16, fontWeight: "bold" }}
                            className="text-dark"
                          >
                            {moment(fecha).format("L")}
                          </TableCell>
                          <TableCell
                            align="left"
                            style={{ fontSize: 16, fontWeight: "bold" }}
                            className="text-dark"
                          >
                            CIERRE DE CAJA
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{
                              fontSize: 16,
                              color: "#c77f12",
                              fontWeight: "bold",
                            }}
                            className="text-dark"
                          >
                            {new Intl.NumberFormat("es-NI", {
                              style: "currency",
                              currency: "NIO",
                            }).format(totalSalidas)}
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{
                              fontSize: 16,
                              color: "#12a35a",
                              fontWeight: "bold",
                            }}
                            className="text-dark"
                          >
                            {new Intl.NumberFormat("es-NI", {
                              style: "currency",
                              currency: "NIO",
                            }).format(totalEntradas)}
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{
                              fontSize: 16,
                              color: "#1d4ed8",
                              fontWeight: "bold",
                            }}
                            className="text-dark"
                          >
                            {new Intl.NumberFormat("es-NI", {
                              style: "currency",
                              currency: "NIO",
                            }).format(cierre)}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>

                  <hr />
                </div>
              </>
            )}
          </Container>
        </PrintReport>
      </div>
    </div>
  );
};

export default CierreCajaDetallado;
